import Vue from 'vue'

Vue.component('block-good', require('./good').default)
Vue.component('block-good-img', require('./good-img').default)
Vue.component('block-event', require('./event').default)
Vue.component('block-event-img', require('./event-img').default)
Vue.component('block-region', require('./region').default)
Vue.component('block-hints', require('./hints').default)
Vue.component('block-balance', require('./balance').default)
Vue.component('block-upgrade', require('./upgrade').default)
Vue.component('block-map', require('./map').default)
Vue.component('block-action', require('./action').default)
Vue.component('block-share', require('./share').default)
Vue.component('block-popup-ebay', require('./popup-ebay').default)
Vue.component('block-control', require('./control').default)
